import React, { useEffect, useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import "bootstrap/dist/css/bootstrap.min.css";
import "./categoryDropdown.css";
import ICategory from "../../../interfaces/ICategory";
import { useNavigate } from "react-router-dom";
import SubDropdown from "./subDropdown";

const CategoryDropdown = ({ 
  currentCategoryID,  
  category,
  onItemSelected
}: {currentCategoryID:any;
  category: ICategory;
  onItemSelected: () => void;
}) => {
  const navigate = useNavigate();
  const nav = (evt: React.MouseEvent, url: string) => {
    evt.preventDefault();
    onItemSelected();
    navigate(url);
  };
  const [isShown, setIsShown] = useState(false);
  
  const [subCurrentCategoryID, setSubCurrentCategoryID] = useState(window.localStorage.getItem("subCurrentCategoryID")); 
  

  useEffect(()=>{
    setSubCurrentCategoryID(window.localStorage.getItem("subCurrentCategoryID"))
  })

  return (
    <div>
      <Dropdown
        className="company-info-dropdown-button"
        id="dropdown-dark-button"
        show={isShown}
        onToggle={() => {setIsShown(!isShown);}}
      >
        <Dropdown.Toggle variant={`${category.categoryTagId==currentCategoryID?"primary":"dark"}`}>{category.menuName}</Dropdown.Toggle>
        <Dropdown.Menu onClick={(evt)=>{
           window.localStorage.setItem("currentCategoryID",category.categoryTagId)           
        }}>
          {category &&
            category.children.map((it: ICategory, index: number) => (
              <React.Fragment key={index}>
                {it.children.length > 0 ? (
                  <SubDropdown                    
                    category={it}                   
                    onItemSelected={() => {
                      onItemSelected();  
                      window.localStorage.setItem("currentCategoryID",category.categoryTagId)
                      window.localStorage.setItem("subCurrentCategoryID",it.categoryTagId)
                      setSubCurrentCategoryID(window.localStorage.getItem("subCurrentCategoryID"))
                      setIsShown(false);
                    }}
                  />
                ) : (
                  <Dropdown.Item className={`${it.categoryTagId==subCurrentCategoryID?"active":""}`}
                    onClick={(evt) =>{   
                      window.localStorage.setItem("currentCategoryID",category.categoryTagId)
                      window.localStorage.setItem("subCurrentCategoryID",it.categoryTagId)
                      setSubCurrentCategoryID(window.localStorage.getItem("subCurrentCategoryID"))  
                      window.localStorage.setItem("thirdCurrentCategoryID", "")             
                      nav(evt, `/category/${it.categoryTagId}`)
                    }}
                  >
                    {it.menuName}
                  </Dropdown.Item>
                )}
              </React.Fragment>
            ))}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

export default CategoryDropdown;
